<script setup>
import EntityHistoryView from "@/shared/ui/history/EntityHistoryView.vue";

defineProps({
  selectedUser: {
    type: Object,
    default: () => null,
  },
});
</script>

<template>
  <EntityHistoryView entity-type="user" :entity-id="selectedUser?.uuid" />
</template>
